<script setup lang="ts">
import type { Category } from '#shared/types/deal'

const { data: categories, pending } = await useFetch<Category[]>('/categories', {
  baseURL: useRuntimeConfig().public.apiBaseUrl,
  key: 'sidebar-categories',
  server: false,
  default: () => [],
})
</script>

<template>
  <aside class="w-56 shrink-0 hidden lg:block">
    <nav class="sticky top-20 space-y-1 overflow-y-auto max-h-[calc(100vh-5rem)] pb-4">
      <p class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400 px-3 mb-2">
        Categorias
      </p>
      <UButton
        to="/"
        variant="ghost"
        color="neutral"
        class="w-full justify-start"
        active-class="bg-primary-50 text-primary-600 dark:bg-primary-900/20 dark:text-primary-400"
      >
        <template #leading>
          <UIcon name="i-heroicons-fire" class="text-primary-500" />
        </template>
        Todas as Ofertas
      </UButton>

      <template v-if="!pending && categories.length">
        <UButton
          v-for="cat in categories"
          :key="cat.id"
          :to="`/categoria/${cat.slug}`"
          variant="ghost"
          color="neutral"
          class="w-full justify-start"
          active-class="bg-primary-50 text-primary-600 dark:bg-primary-900/20 dark:text-primary-400"
        >
          <template #leading>
            <span v-if="cat.icon">{{ cat.icon }}</span>
            <UIcon v-else name="i-heroicons-tag" />
          </template>
          {{ cat.name }}
        </UButton>
      </template>

      <template v-else>
        <USkeleton v-for="i in 8" :key="i" class="h-8 w-full rounded-lg" />
      </template>
    </nav>
  </aside>
</template>
